'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    validator = require('./validator'),
    recaptchaUtils = require('./recaptcha-utils');

var login = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function () {
        //o-auth binding for which icon is clicked
        $('.oAuthIcon').bind('click', function () {
            $('#OAuthProvider').val(this.id);
        });

        // Add recaptcha events to forms that are part of the login process (recaptchaUtils will check if the specific form exists since this is in a shared initialization function)
        recaptchaUtils.registerRecaptchaFormPassthrough('form.recaptcha-registration-form', '.recaptcha-submit', 'button.submit-requiring-recaptcha');
        recaptchaUtils.registerRecaptchaFormPassthrough('form.recaptcha-login-form', '.recaptcha-submit', 'button.submit-requiring-recaptcha');
        recaptchaUtils.registerRecaptchaFormPassthrough('form.recaptcha-checkout-login-form', '.recaptcha-submit', 'button.submit-requiring-recaptcha');

        //toggle the value of the rememberme checkbox
        $('#dwfrm_login_rememberme').bind('change', function () {
            if ($('#dwfrm_login_rememberme').attr('checked')) {
                $('#rememberme').val('true');
            } else {
                $('#rememberme').val('false');
            }
        });

        $('#password-reset, #one-time-login').on('click', function (e) {
            e.preventDefault();
            dialog.open({
                url: $(e.target).attr('href'),
                options: {
                    dialogClass: 'ui-dialog--relax',
                    open: function () {
                        validator.init();

                        $('body').on('click', '[name$="_requestpassword_send"]', function (e) {
                            var $submit = $(e.currentTarget);
                            if ($submit.hasClass('js-pending-send')) {
                                return;
                            }
                            $submit.addClass('js-pending-send');
                            var $requestPasswordForm = $submit.closest('form');
                            if (!$requestPasswordForm.valid()) {
                                $submit.removeClass('js-pending-send');
                                return;
                            }
                            e.preventDefault();
                            var data = $requestPasswordForm.serialize();
                            // add form action to data
                            data += '&' + $submit.attr('name') + '=';
                            // make sure the server knows this is an ajax request
                            if (data.indexOf('ajax') === -1) {
                                data += '&format=ajax';
                            }
                            $.ajax({
                                type: 'POST',
                                url: $requestPasswordForm.attr('action'),
                                data: data,
                                success: function (response) {
                                    if (typeof response === 'object' &&
                                            !response.success &&
                                            response.error === Resources.CSRF_TOKEN_MISMATCH) {
                                        page.redirect(Urls.csrffailed);
                                    } else if (typeof response === 'string') {
                                        dialog.$container.html(response);
                                        validator.init();
                                    }
                                },
                                failure: function () {
                                    dialog.$container.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
                                },
                                always: function () {
                                    $submit.removeClass('js-pending-send');
                                }
                            });
                        });
                    }
                }
            });
        });
    }
};

module.exports = login;
